import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Cell } from '../Grid/Grid.js';

var FormLayout = function FormLayout(props) {
  return React.createElement(Grid, null, React.createElement(Row, null, React.createElement(Cell, _extends({
    offsetLarge: 1,
    size: 12,
    sizeMedium: 9,
    sizeLarge: 6
  }, props))));
};

FormLayout.displayName = 'FormLayout';
FormLayout.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default FormLayout;